import React from "react";
import logo from "../../assets/images/scan.png";
import { fontText } from "../../assets/fontConstant";
import { Button, Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

export default function Rescan() {
  const navigate = useNavigate();
  const logo_img = logo;
  return (
    <>
      <div>
        <div id="content">
          <section className="section pt-0 pb-0">
            <div className="container">
              <div className="row">
                <div className="col-xl-8 pull-xl-4 col-lg-7 pull-lg-5">
                  <div className="bg-white p-4 p-md-5 mb-4">
                    <div className="row mb-2 thankyou-maindiv1">
                      <div className="form-group thankyou-maindiv mb-2">
                        <h3
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "900",
                            marginBottom: "0rem",
                            color: "#b51515",
                          }}
                        >
                          {" "}
                          Scan Again!
                        </h3>
                        <p style={{ fontFamily: "Satoshi", fontSize: "1rem" }}>
                          Whoops! Link disconnected{" "}
                        </p>
                        <img
                          className="storeclose33"
                          alt="orderfail"
                          src={logo_img}
                        />
                      </div>
                      <div className="form-group thankyou-maindiv mb-2">
                        <p
                          className="thankyou-para2 mb-0"
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "1.5rem",
                            lineHeight: "2rem",
                            fontWeight: "600",
                            marginTop: "0rem",
                          }}
                        >
                          Reconnect with a quick Scan!
                        </p>
                      </div>
                      <div className="form-group thankyou-maindiv mb-3">
                        <p
                          className="mb-0 storeclose34"
                          style={{ fontFamily: fontText.NormalText }}
                        >
                          {/* Please rescan your QR */}
                        </p>
                      </div>
                      <div className="form-group thankyou-maindiv mb-2 storeclose-tryagain">
                        {/* <Link to="/">
                                                <MainBtn name="Try again!" />
                                            </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Grid
              style={{
                left: "0px",
                position: "fixed",
                right: "0px",
                bottom: "0px",
                padding: "1.4rem",
                margin: "0px 0px",
                borderRadius: "2rem 2rem 0rem 0rem",
              }}
            >
              <Grid
                container
                justifyContent="space-evenly"
                style={{ paddingTop: "2rem" }}
              >
                {/* <Button
                  style={{
                    fontSize: "1.3rem",
                    borderRadius: "1rem",
                    minWidth: "100%",
                    color: "white",
                    padding: "1rem",
                    backgroundColor: "black",
                  }}
                  variant="contained"
                  onClick={() =>
                    window.location.replace("https://qrcodescan.in")
                  }
                >
                  Scan Again
                </Button> */}
                {/* <Button
                style={{
                  borderRadius: "0.6rem",
                  padding: "0rem 2rem",

                  color: "black",
                }}
                variant="contained"
                onClick={() => navigate("/cart")}
              >
                Close
              </Button> */}
              </Grid>
            </Grid>
          </section>
        </div>
      </div>
    </>
  );
}
